/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { FC } from 'react';
import { Link, Stack } from '@mui/material';
import { useSelector } from 'react-redux';

import { selectRemoteConfig } from '../../../../services/firebase/remote-config/remoteConfig.slice';
import TestIds from '../../../../testIds';

import './UserAgreements.scss';

const UserAgreements: FC = (): JSX.Element | undefined => {
  const remoteConfig = useSelector(selectRemoteConfig);

  const privacyPolicyUrl: string | undefined = remoteConfig.privacyPolicyUrl?.trim();
  const termsAndConditionsUrl: string | undefined = remoteConfig.termsAndConditionsUrl?.trim();

  if (privacyPolicyUrl || termsAndConditionsUrl) {
    return (
      <Stack
        className='fl-user-agreements'
        data-testid={TestIds.feat.account.userAccount.userAgreements.component}
        spacing='1rem'
      >
        {privacyPolicyUrl && (
          <Link
            variant='farmlands2.0_default'
            color='primary'
            href={privacyPolicyUrl}
            target='_blank'
            rel='noreferrer'
            data-testid={TestIds.feat.account.userAccount.userAgreements.privacyLink}
          >
            Privacy Policy
          </Link>
        )}

        {termsAndConditionsUrl && (
          <Link
            variant='farmlands2.0_default'
            color='primary'
            href={termsAndConditionsUrl}
            target='_blank'
            rel='noreferrer'
            data-testid={TestIds.feat.account.userAccount.userAgreements.termsLink}
          >
            Terms & Conditions
          </Link>
        )}
      </Stack>
    );
  }
};

export default UserAgreements;
